import { computed, debug, NetbankingAPI } from "aaa";
import { action, observable } from "mobx";
import { ContactsStore } from "stores/ContactsStore";
import { IDataConsents } from "types/profile";
import { ISigningInfo } from "types/signing";
import { NetbankingAPIClient } from "network/APIClient";
import { IPreference, IPreferenceList, IPreferenceSection, IPutPreferenceListPayload } from "types/tradingPreferences";


export class TradingPreferencesStore {
    @observable _isLoading = true;

    @observable contactsStore: ContactsStore;

    @observable dataConsents?: IDataConsents;
    @observable marketingInfoApproval: boolean = false;

    @observable signInfo?: ISigningInfo;

    @observable preferences: (IPreference & { sectionId: string })[] = [];

    @observable isDataConsentLoading = false;

    constructor() {
        this.contactsStore = new ContactsStore(false, true);
    }

    @computed get isLoading() {
        return this._isLoading || this.contactsStore.isLoading;
    }

    @action async loadData() {
        try {
            this._isLoading = true;

            const response = await Promise.all([
                this.contactsStore.load(),
                NetbankingAPIClient.requestType(NetbankingAPI.getMarketingInformation()),
                NetbankingAPIClient.requestType(NetbankingAPI.getTradingPreferences())
            ]);

            this.prepareMarketingApproval(response[1]);
            this.preparePreferences(response[2])

            this._isLoading = false;
        } catch (error) {
            debug.log("[TradingPreferencesStore] loadData error:", error);
            throw error;
        }
    }

    @action async postTradingPreferences() {
        try {
            this._isLoading = true;

            const emailId = this.contactsStore.selectedEmailAddressId;
            if (!emailId) {
                throw new Error("Email Id is missing");
            }

            const preferences: IPreferenceSection[] = Object.values(
                this.preferences.reduce<Record<string, IPreferenceSection>>(
                    (acc, { sectionId, ...preference }) => {
                        if (!acc[sectionId]) {
                            acc[sectionId] = {
                                sectionId,
                                items: []
                            };
                        }

                        acc[sectionId].items.push(preference);
                        return acc;
                    },
                    {}
                )
            );

            const payload: IPutPreferenceListPayload = {
                emailId,
                preferences
            };

            const target = NetbankingAPI.putTradingPreferences(payload);
            const response = await NetbankingAPIClient.requestType(target);
            this.signInfo = response.signInfo;

            this._isLoading = false;
        } catch (error) {
            this._isLoading = false;
            debug.log("### postTradingPreferences failed", error);
            throw error;
        }
    }

    @action refetchDataConsent = async () => {
        this.isDataConsentLoading = true;
        const response = await NetbankingAPIClient.requestType(NetbankingAPI.getMarketingInformation())
        this.prepareMarketingApproval(response);
        this.isDataConsentLoading = false;
    }

    @action togglePreference = (id: string) => {
        const pref = this.preferences.find(p => p.itemId === id);
        if (pref) {
            pref.enabled = !pref.enabled;
        }
    }

    private prepareMarketingApproval(response: IDataConsents) {
        this.dataConsents = response;
        this.marketingInfoApproval = response.consents.find(consent => consent.type === "MARKETING")?.status === "AGREE";
    }

    private preparePreferences(preferencesList: IPreferenceList) {
        this.preferences = preferencesList?.preferences?.reduce((acc, section) => {
            if (section.active && section.sectionId) {
                const activeItems = section.items
                    .filter(item => item.active)
                    .map(item => ({ ...item, sectionId: section.sectionId }));
                acc.push(...activeItems);
            }

            return acc;
        }, [] as (IPreference & { sectionId: string })[])

    }

}



// WEBPACK FOOTER //
// ./src/components/tradingPreferences/TradingPreferencesStore.tsx